import React from "react";
import ErrorLoader from "./ErrorLoader";
import { useLocation } from "react-router-dom";

const ErrorBoundaryWithRouter = (props) => {
  const location = useLocation();
  return <ErrorBoundary {...props} location={location} />;
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught an error:", error, info);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex center">
          <ErrorLoader />
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundaryWithRouter;
